<div class="flex items-center justify-between mb-4">
  <h2 class="text-xl font-semibold">User sync queues</h2>
  <button pButton type="button"
          icon="pi pi-refresh"
          label="Refresh"
          (click)="reloadQueues()"
          [disabled]="loading()"></button>
</div>

<p-progressSpinner *ngIf="loading()" styleClass="block mx-auto my-8"/>

<p-table *ngIf="!loading()" [value]="queueStates()" responsiveLayout="scroll">
  <ng-template pTemplate="header">
    <tr>
      <th>Queue</th>
      <th>Queued users</th>
      <th>Listener</th>
      <th>Action</th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-row>
    <tr>
      <td>{{ labelFor(row.queue) }}</td>
      <td>{{ row.count }}</td>
      <td>
        <p-tag [value]="row.listenerEnabled ? 'Enabled' : 'Paused'"
               [severity]="row.listenerEnabled ? 'success' : 'danger'">
        </p-tag>
      </td>
      <td>
        <button pButton type="button"
                [label]="row.listenerEnabled ? 'Pause listener' : 'Resume listener'"
                [icon]="row.listenerEnabled ? 'pi pi-pause' : 'pi pi-play'"
                (click)="toggleListener(row)"
                [disabled]="isToggling(row.queue)"></button>
      </td>
    </tr>
  </ng-template>
</p-table>
